'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X, ChevronRight } from 'lucide-react';

const navLinks = [
  { id: 'nav-features', label: 'Features', href: '#features' },
  { id: 'nav-how', label: 'How It Works', href: '#dashboard-preview' },
  { id: 'nav-pricing', label: 'Pricing', href: '#pricing' },
  { id: 'nav-enterprise', label: 'Enterprise', href: '#pricing' },
];

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-card/95 backdrop-blur-md border-b border-border shadow-card' : 'bg-transparent'
    }`}>
      <div className="max-w-screen-xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2">
          <AppLogo size={28} />
          <span className="font-semibold text-sm text-foreground tracking-tight">GlobalAtlas</span>
          <span className="text-2xs px-1.5 py-0.5 rounded border border-primary/30 text-primary font-semibold hidden sm:inline">Beta</span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-1">
          {navLinks?.map((link) => (
            <a
              key={link?.id}
              href={link?.href}
              className="px-4 py-2 text-sm text-muted-foreground hover:text-foreground transition-colors rounded-md hover:bg-muted"
            >
              {link?.label}
            </a>
          ))}
        </div>

        {/* CTAs */}
        <div className="hidden md:flex items-center gap-3">
          <Link
            href="/sign-up-login-screen"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors px-3 py-2"
          >
            Sign In
          </Link>
          <Link
            href="/sign-up-login-screen"
            className="flex items-center gap-1.5 bg-primary text-primary-foreground text-sm font-semibold px-4 py-2 rounded-md hover:opacity-90 active:scale-95 transition-all duration-150"
          >
            Get Early Access
            <ChevronRight size={14} />
          </Link>
        </div>

        {/* Mobile toggle */}
        <button
          className="md:hidden p-2 text-muted-foreground hover:text-foreground"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-card border-t border-border px-6 py-4 space-y-1 animate-fade-in">
          {navLinks?.map((link) => (
            <a
              key={`mobile-${link?.id}`}
              href={link?.href}
              onClick={() => setMobileOpen(false)}
              className="block px-3 py-2.5 text-sm text-muted-foreground hover:text-foreground rounded-md hover:bg-muted transition-colors"
            >
              {link?.label}
            </a>
          ))}
          <div className="pt-3 border-t border-border flex flex-col gap-2">
            <Link href="/sign-up-login-screen" className="block px-3 py-2.5 text-sm text-center text-muted-foreground border border-border rounded-md">
              Sign In
            </Link>
            <Link href="/sign-up-login-screen" className="block px-3 py-2.5 text-sm text-center font-semibold bg-primary text-primary-foreground rounded-md">
              Get Early Access
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}